"use strict";

require("core-js/modules/es.object.assign.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["stroke", "width", "height"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const Cube2dSVG = _ref => {
  let {
      stroke = '#00205B',
      width = 24,
      height = 24
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4 10V5C4 4.44772 4.44772 4 5 4H10",
    stroke: stroke,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20 14V19C20 19.5523 19.5523 20 19 20H14",
    stroke: stroke,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14 4L19 4C19.5523 4 20 4.44772 20 5L20 10",
    stroke: stroke,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 20L5 20C4.44772 20 4 19.5523 4 19L4 14",
    stroke: stroke,
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.824 14.483V15.5H11.432V14.357H8.687L9.74 13.511C10.604 12.827 11.378 12.08 11.378 11.009C11.378 9.785 10.487 8.939 9.101 8.939C7.85 8.939 6.806 9.803 6.806 11.054C6.806 11.297 6.833 11.486 6.914 11.738H8.165C8.093 11.549 8.057 11.342 8.057 11.135C8.057 10.55 8.453 10.064 9.074 10.064C9.695 10.064 10.064 10.505 10.064 11.099C10.064 11.828 9.362 12.395 8.498 13.106L6.824 14.483ZM12.2525 15.5H14.4755C16.5095 15.5 17.7515 14.24 17.7515 12.269C17.7515 10.298 16.5095 9.038 14.4755 9.038H12.2525V15.5ZM13.5485 14.366V10.172H14.4665C15.7265 10.172 16.4465 10.991 16.4465 12.269C16.4465 13.538 15.7265 14.366 14.4755 14.366H13.5485Z",
    fill: stroke
  }));
};
var _default = exports.default = Cube2dSVG;